"use client"
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

interface BreadcrumbContextProps {
    crumbs?: string[];
    changeBreadcrumb: (crumbs?: string[]) => void;
    addElement: (element: string) => void;
    deleteElement: () => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextProps | null>(null);
export const useBreadcrumb = (): BreadcrumbContextProps => {
    const context = useContext(BreadcrumbContext);
    if (!context) throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
    return context;
};

export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
    const [crumbs, setCrumbs] = useState<string[] | undefined>(undefined);
    const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

    const changeBreadcrumb = (newCrumbs?: string[]) => {
        setCrumbs(newCrumbs && newCrumbs.length > 0 ? [...newCrumbs] : undefined);
    };

    function addElement(element: string): void {
        setCrumbs(prev => {
            const list = prev ?? [];
            return [...list, element];
        });
    }
function deleteElement(): void {
  setCrumbs(prev => {
    const list = prev ?? [];
    // crea un nuovo array senza l'ultimo elemento
    return list.slice(0, -1);
  });
}


    useEffect(() => {
        const root = document.getElementById('breadcrumb-root');
        setPortalRoot(root);
    }, []);

    const breadcrumbElement = crumbs ? (
        <MuiBreadcrumbs
            separator={<FontAwesomeIcon icon={faAngleRight} className="tw:opacity-70" />}
            aria-label="breadcrumb"
        >
            {crumbs.map((label, idx) => (
                <Typography
                    key={`${label}-${idx}`}
                    variant="body2"
                    color={idx === crumbs.length - 1 ? 'primary' : undefined}
                    className={idx < crumbs.length - 1 ? 'tw:opacity-70' : ''}
                >
                    {label}
                </Typography>
            ))}
        </MuiBreadcrumbs>
    ) : null;

    return (
        <BreadcrumbContext.Provider value={{ crumbs, changeBreadcrumb, addElement, deleteElement}}>
            {/* Se c’è portalRoot e crumbs, monta lì */}
            {portalRoot && breadcrumbElement
                ? createPortal(breadcrumbElement, portalRoot)
                : breadcrumbElement}
            {children}
        </BreadcrumbContext.Provider>
    );
};
